<template>
  <div class="signup min-h-screen flex justify-center items-center">
    <form @submit.prevent="handleSubmit" class="signup-container m-4 w-full rounded-md flex flex-col">
      <input required name="email" v-model="email" class="mt-2 mb-3 px-4 py-3 text-gray-900 bg-gray-50 border border-gray-800 rounded" type="email" placeholder="Your Email" />

      <input required name="password" v-model="password" class="mt-2 mb-3 px-4 py-3 text-gray-900 bg-gray-50 border border-gray-800 rounded" type="password" placeholder="Your Password" />

      <button class="mt-2 px-4 py-3 text-white font-bold bg-green-600 border border-green-500 rounded">Login</button>

      <div v-if="error" class="my-4 text-red-500">{{ error }}</div>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import useLogin from "../composables/useLogin";

export default {
  setup() {
    const email = ref("");
    const password = ref("");

    const { login, error } = useLogin();
    const router = useRouter();

    const handleSubmit = async () => {
      await login(email.value, password.value);

      if (!error.value) {
        router.push("/");
      }
    };

    return { email, password, handleSubmit, error };
  },
  name: "Signup",
  components: {},
};
</script>

<style>
.signup-container {
  max-width: 350px;
}
</style>
